import { render, staticRenderFns } from "./BigScreenForWXCW2.vue?vue&type=template&id=04ad0cef&scoped=true&"
import script from "./BigScreenForWXCW2.vue?vue&type=script&lang=js&"
export * from "./BigScreenForWXCW2.vue?vue&type=script&lang=js&"
import style0 from "./BigScreenForWXCW2.vue?vue&type=style&index=0&id=04ad0cef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ad0cef",
  null
  
)

export default component.exports